import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
// Styles
import styles from './styles';

import { push } from 'react-router-redux';
import { changePassword } from './service';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

const ChangePassword = props => {
  const { classes } = props;
  const [resultMessage, setResultMessage] = useState({
    isVisible: false,
    tittle: '',
    message: '',
  });
  const [user, setUser] = useState({
    password_confirmation: '',
    password: '',
    isValidated: false,
    validPassword: false,
  });

  const submitChangePassword = async () => {
    if (user.isValidated === false) {
      setUser({ ...user, isValidated: true });
    }

    if (!user.password || !user.password_confirmation) {
      return;
    }

    if (user.password_confirmation !== user.password) {
      setResultMessage({
        isVisible: true,
        tittle: 'Contraseñas no coinciden',
        message: 'La contraseña y la confirmación deben coincidir, por favor reingresarlas.',
      });
      return;
    } else if (resultMessage.isVisible){
      setResultMessage({ isVisible: false, tittle: '', message: '', })
    }

    if (user.password_confirmation && user.password) {
      const response = await changePassword(user);

      //* *200 authorized*/
      if (response && response.status === 200) {
        if (response.data.role === 'collaborator') {
          props.history.push('/home');
          push('/home');
        } else {
          props.history.push('/requests');
          push('/requests');
        }
      } else {
        setResultMessage({
          isVisible: true,
          tittle: 'Contraseña usada anteriormente',
          message: 'La contraseña ya fue utilizada anteriormente.',
        })
      } 
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.main}>
        <p className={classes.labelTitle}>Actualizar la contraseña es requerido para continuar</p>
        <br />
        <p className={classes.labelCaption}>Contraseña</p>
        <TextField
          id="password"
          className={classes.textField}
          type="password"
          margin="normal"
          inputProps={{
            'aria-label': 'bare'
          }}
          placeholder="Clave"
          value={user.password}
          onChange={e => {
            setUser({ ...user, password: e.target.value });
          }}
        />
        {user.isValidated && !user.password ? (
          <p className={classes.validationLabel}>Por favor insertar una contraseña</p>
        ) : null}
        <br />
        <br />
        <p className={classes.labelCaption}>Confirmar Contraseña</p>
        <TextField
          id="passwordConfirmation"
          className={classes.textField}
          type="password"
          margin="normal"
          inputProps={{
            'aria-label': 'bare'
          }}
          placeholder="Confirmar Clave"
          value={user.password_confirmation}
          onChange={e => {
            setUser({ ...user, password_confirmation: e.target.value });
          }}
        />
        {user.isValidated && !user.password_confirmation ? (
          <p className={classes.validationLabel}>Por favor confimar la contraseña</p>
        ) : null}
        <div className={classes.actions}>
          <Button
            variant="contained"
            color="secondary"
            className={classes.button}
            onClick={() => {
              submitChangePassword();
            }}
          >
            Cambiar
          </Button>
        </div>
        {resultMessage.isVisible ? (
          <p className={classes.validationLabel}>{resultMessage.message}</p>
        ) : null}
      </div>
    </div>
  );
};

export default withStyles(styles)(ChangePassword);
